import * as React from "react";
import {
  ActivityFragment,

  CompanyMinimalFragment, GroupFragment
} from "../../../graphql/fragments";
import useTranslations from "../../../hooks/useTranslations";
import { BuildingIcon } from "../../icons";
import { Link } from "../../wombat-ui";
import { Span } from "../../wombat-ui/components/Typography";
import Activity from "../ActivityPlate";

type GroupCreatedActivity = ActivityFragment & {
  recipient: CompanyMinimalFragment;
  trackable: GroupFragment;
};

export function isGroupCreatedActivity(
  q: ActivityFragment
): q is GroupCreatedActivity {
  return q.key === "group.created";
}

interface GroupCreatedActivityProps {
  activity: GroupCreatedActivity;
}

export const GroupCreatedActivity: React.FC<GroupCreatedActivityProps> = ({
  activity,
}) => {
  const t = useTranslations();

  return (
    <Activity
      activity={activity}
      id="groupCreatedActivity"
      visual={<BuildingIcon iconClassName="w-10 h-10 text-accent-500" />}
    >
      <Span className="text-sm">
        {t("activity.labels.groupCreated", {
          group: (
            <Link
              to={`/users?groupId=${activity.trackable.id}`}
              key={activity.id}
            >
              {t("activity.objects.group")}
            </Link>
          ),
        })}
      </Span>
    </Activity>
  );
};
